// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var SecuritySettingsController = function ($scope, SecuritySettings) {
    $scope.securitySettings = SecuritySettings.get();

    $scope.save = function () {
        $scope.securitySettings.$update({}, function () {
            $scope.notifySuccess();
        });
    };
};
SecuritySettingsController.$inject = ['$scope', 'SecuritySettings'];
